// extracted by mini-css-extract-plugin
export default {"container":"Jp-z","ratingLayout":"Kp-z","ratingLabel":"Lp-z","nonInteractiveRatingLabel":"Mp-z"};